import React from 'react'

export default ({ className = '' }) => {
  return <i className={ `ph ph-circle-notch spin ${className}`} />
}
